import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { FormattedDate } from 'components/intl'
import { Modal } from 'containers/misc'
import { Title } from 'components/layout'
import { FormData, Status, Button } from 'components/misc'

export default class AwardUnitDetailModal extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    modal: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
  }

  static defaultProps = {
    data: {}
  }

  render() {
    const { modalId, data } = this.props
    const middleName = get(data, 'awardLeaderRegistration.middleName')
    const colClass = middleName ? 'col-xs-12' : 'col-xs-6'

    return (
      <Modal id={modalId} customActions>
        <Title h2 intlKey="moduleTitle.award_unit">
          Award Unit
        </Title>
        <div className="row">
          <div className="col-xs-6">
            <FormData label="Name" intlKey="label.name">
              {get(data, 'organization.name')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData
              label="Organization type"
              intlKey="label.organization_type"
            >
              {get(data, 'organization.organizationType.translationText')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Already running" intlKey="label.already_running">
              <Status
                state={get(data, 'organization.alreadyRunningAward')}
                check
                inline
              />
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Online payments" intlKey="label.online_payments">
              <Status
                state={Boolean(get(data, 'acceptingOnlinePayment'))}
                check
                inline
                noWaiting
              />
            </FormData>
          </div>
        </div>

        <Title h2 intlKey="moduleTitle.main_award_leader">
          Main Award Leader
        </Title>

        <div className="row">
          <div className="col-xs-6">
            <FormData label="First Name" intlKey="label.first_name">
              {get(data, 'awardLeaderRegistration.firstName') || '---'}
            </FormData>
          </div>
          {middleName &&
            <div className="col-xs-6">
              <FormData label="Middle Name" intlKey="label.middle_name">
                {middleName || '---'}
              </FormData>
            </div>}
          <div className={colClass}>
            <FormData label="Last Name" intlKey="label.last_name">
              {get(data, 'awardLeaderRegistration.lastName') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Email" intlKey="label.email">
              {get(data, 'awardLeaderRegistration.email') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Minimum age confirmation" intlKey="label.min_age_confirmation">
              {Math.floor(get(data, 'awardLeaderRegistration.minAgeValue') / 12)}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Phone" intlKey="label.phone">
              {get(data, 'awardLeaderRegistration.phoneNumber')}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Phone type" intlKey="label.phone_type">
              {get(data, 'awardLeaderRegistration.phoneType.translationText') ||
                '---'}
            </FormData>
          </div>
        </div>

        <Title h2 intlKey="moduleTitle.billing_address">
          Billing Address
        </Title>

        <div className="row">
          <div className="col-xs-12">
            <FormData label="Address Line 1" intlKey="label.addressLine1">
              {get(data, 'organization.invoiceAddress.line1') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Address Line 2" intlKey="label.addressLine2">
              {get(data, 'organization.invoiceAddress.line2') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Post Code" intlKey="label.post_code">
              {get(data, 'organization.invoiceAddress.zipCode') || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Address Line 2" intlKey="label.state_province">
              {get(
                data,
                'organization.invoiceAddress.stateOrProvinceOrRegion'
              ) || '---'}
            </FormData>
          </div>
          <div className="col-xs-6">
            <FormData label="Post Code" intlKey="label.country">
              {get(data, 'organization.invoiceAddress.country.name') || '---'}
            </FormData>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 text--right">
            <Button
              type="button"
              intlKey="button.close"
              onClick={() => this.props.modal(null)}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}
